'use client';

import React, { PropsWithChildren } from 'react';

import AuthProvider from '@/providers/AuthProvider/AuthProvider';
import NotificationBannerProvider from '@/providers/NotificationBannerProvider';
import ProgressProvider from '@/providers/ProgressProvider';
import RollbarProvider from '@/providers/RollbarProvider';
import StoreProvider from '@/providers/StoreProvider';
import ThemeProvider from '@/providers/ThemeProvider';
import { StoreInterface } from '@/stores/store';
import { User } from '@/typings/user';

type Props = {
  initialStoreData?: Partial<Omit<StoreInterface, 'updateData'>>;
  user?: User;
};

const Providers: React.FC<PropsWithChildren<Props>> = ({
  children,
  initialStoreData = {},
  user,
}) => {
  return (
    <RollbarProvider>
      <StoreProvider initialData={{ ...initialStoreData }}>
        <AuthProvider initialUser={user}>
          <ThemeProvider>
            <ProgressProvider>
              <NotificationBannerProvider>{children}</NotificationBannerProvider>
            </ProgressProvider>
          </ThemeProvider>
        </AuthProvider>
      </StoreProvider>
    </RollbarProvider>
  );
};

export default Providers;
